// Mobile Menu //
// Hamburger Menu //
const hamburger = document.getElementById('hamburger-button');
const menu = document.getElementById('menu');
const mobileSubnav = document.getElementById('mobile-subnav'); // Select the mobile subnav

hamburger.addEventListener('click', () => {
  const img = hamburger.querySelector('img');
  const isMenuOpen = menu.style.display === 'block';

  // Toggle menu display
  menu.style.display = isMenuOpen ? 'none' : 'block';

  // Toggle mobile subnav display
  mobileSubnav.style.display = isMenuOpen ? 'none' : 'block';

  // Switch hamburger icon
  img.src = isMenuOpen 
    ? 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-hamburger.svg?v=1732656615' 
    : 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-close.svg?v=1732659101';
});

// Screen Resize Listener //
window.addEventListener('resize', () => {
  if (window.innerWidth > 948) {
    // Hide the mobile subnav and menu if the screen width is greater than 958px
    mobileSubnav.style.display = 'none';
    menu.style.display = 'flex';

    // Reset the hamburger icon
    const img = hamburger.querySelector('img');
    img.src = 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-hamburger.svg?v=1732656615';
  }
});

// Mobile Menu Dropdown Click Handling
document.querySelectorAll('#mobile-menu .dropdown > a').forEach((dropdownLink) => {
  dropdownLink.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent the default link behavior
    const parentDropdown = dropdownLink.parentElement;

    // Toggle the visibility of the subnav
    const subnav = parentDropdown.querySelector('.subnav');
    if (subnav) {
      subnav.style.display = subnav.style.display === 'block' ? 'none' : 'block';
    }
  });
});

// Mega Menu Hover Handling
document.querySelectorAll('.menu-item.dropdown a').forEach((item) => {
  // Show mega menu on hover over the menu item
  item.addEventListener('mouseenter', function () {
    const targetId = item.dataset.item;
    const target = document.querySelector(`#${CSS.escape(targetId)}`);

    // Add active class to the current item
    item.classList.add('se');

    // Remove 'active' class from all mega menu content and add to the target
    document.querySelectorAll('.mega-menu-content').forEach(div => div.classList.remove('active'));
    if (target) target.classList.add('active');

    // Show the mega menu container
    document.querySelector('#mega-menu-container').style.display = 'block';
  });

  // Track mouse leave event on the menu item
  item.addEventListener('mouseleave', function () {
    // Remove the active class from the current item
    item.classList.remove('active');
    
    // Hide mega menu only when mouse leaves both the item and the container
    checkIfShouldHideMegaMenu();
  });
});

// Additional event listener for the mega menu container to handle mouse leave
document.querySelector('#mega-menu-container').addEventListener('mouseleave', function () {
  checkIfShouldHideMegaMenu();
});

// Function to check if both the item and container should hide the mega menu
function checkIfShouldHideMegaMenu() {
  const megaMenuContainer = document.querySelector('#mega-menu-container');
  if (!megaMenuContainer.matches(':hover') && !document.querySelector('.menu-item.dropdown:hover')) {
    // Only hide if the mouse has left both the item and the container
    megaMenuContainer.style.display = 'none';
    document.querySelectorAll('.menu-item.dropdown a').forEach(item => item.classList.remove('active'));
  }
}

// Reset the active state when the menu closes or changes
hamburger.addEventListener('click', () => {
  const isMenuOpen = menu.style.display === 'block';

  if (!isMenuOpen) {
    // Remove active class from all menu items when the menu is closed
    document.querySelectorAll('.menu-item.dropdown a').forEach(item => item.classList.remove('active'));
  }
});

// Manages the images  
document.querySelectorAll('.linked-navbar-image').forEach(function (element) {
  const bgImage = element.getAttribute('data-bg-image');
  element.style.backgroundImage = bgImage;
});
